/**
 * Entrega al navegador un archivo que ya esta en memoria, como si se hubiera
 * bajado de un enlace: crea una URL temporal, la "clickea" y la suelta.
 */
export function descargarArchivo(contenido: Blob, nombre: string): void {
  const url = URL.createObjectURL(contenido);
  const enlace = document.createElement('a');
  enlace.href = url;
  enlace.download = nombre;
  document.body.append(enlace);
  enlace.click();
  enlace.remove();
  // Se suelta despues: algunos navegadores leen la URL en la siguiente vuelta.
  window.setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 1000);
}
